<template>
    <div class="payOptionPage">
        <headerNotice routerName="支付设置"></headerNotice>
        <div class="payOptionMain">
            <h2 class="payOptionTitle">
                <i></i>
                <span>编辑支付参数</span>
            </h2>
            <el-tabs v-model="activeName" type="card" width="80%">
                <!-- 客户端小程序 -->
                <el-tab-pane label="客户端小程序" name="0">
                    <div class="payOptionContent" v-loading="loading">
                        <el-form
                            :inline="false"
                            ref="ClientForm"
                            :model="ClientForm"
                            label-width="200px"
                            class="ClientForm"
                        >
                            <div class="formLeft">
                                <el-form-item label="商户号">
                                    <el-input v-model="ClientForm.MchId" clearable></el-input>
                                </el-form-item>
                                <el-form-item label="小程序AppId">
                                    <el-input v-model="ClientForm.AppId" clearable></el-input>
                                </el-form-item>
                                <el-form-item label="小程序AppSecret">
                                    <el-input v-model="ClientForm.AppSecret" clearable></el-input>
                                </el-form-item>
                                <el-form-item label="商户支付密钥Key">
                                    <el-input v-model="ClientForm.Key" clearable></el-input>
                                </el-form-item>
                                <!-- <el-form-item label="受理商ID(即微信支付商户号)">
                                    <el-input v-model="ClientForm.acceptanceId" clearable></el-input>
                                </el-form-item>-->
                                <el-form-item>
                                    <el-upload
                                        :accept='accept'
                                        class="upload-demo"
                                        :headers="headers"
                                        :action="uploadAction"
                                        :on-success="handleAddSuccess"
                                        :on-change="handleChange"
                                        :file-list="clientFileList"
                                    >
                                        <el-button
                                            size="small"
                                            type="primary"
                                            icon="el-icon-upload2"
                                        >点击上传</el-button>
                                        <div
                                            slot="tip"
                                            class="el-upload__tip"
                                        >证书用于企业帐号支付以及退款原路返回，请使用扩展名为p12的证书文件</div>
                                    </el-upload>
                                </el-form-item>
                                <el-form-item>
                                    <!-- <el-button>关闭</el-button> -->
                                    <el-button @click="sendPayOption">提交</el-button>
                                </el-form-item>
                            </div>
                        </el-form>
                    </div>
                </el-tab-pane>
                <!-- 业务员小程序 -->
                <div v-show="false">
                
                <el-tab-pane label="业务员小程序" name="1" v-show="false">
                    <div class="payOptionContent" v-loading="loading">
                        <el-form
                            :inline="false"
                            ref="ClientForm"
                            :model="ClientForm2"
                            label-width="200px"
                            class="ClientForm"
                        >
                            <div class="formLeft">
                                <el-form-item label="商户号">
                                    <el-input v-model="ClientForm2.MchId" clearable></el-input>
                                </el-form-item>
                                <el-form-item label="微信公众号AppId">
                                    <el-input v-model="ClientForm2.AppId" clearable></el-input>
                                </el-form-item>
                                <el-form-item label="微信公众号AppSecret">
                                    <el-input v-model="ClientForm2.AppSecret" clearable></el-input>
                                </el-form-item>
                                <el-form-item label="商户支付密钥Key">
                                    <el-input v-model="ClientForm2.Key" clearable></el-input>
                                </el-form-item>
                                <!-- <el-form-item label="受理商ID(即微信支付商户号)">
                                    <el-input v-model="ClientForm.acceptanceId" clearable></el-input>
                                </el-form-item>-->
                                <el-form-item>
                                    <el-upload
                                        :accept='accept'
                                        class="upload-demo"
                                        :headers="headers"
                                        :action="uploadAction"
                                        :on-success="handleAddSuccess"
                                        :on-change="handleChange"
                                        :file-list="clientFileList"
                                    >
                                        <el-button
                                            size="small"
                                            type="primary"
                                            icon="el-icon-upload2"
                                        >点击上传</el-button>
                                        <div
                                            slot="tip"
                                            class="el-upload__tip"
                                        >证书用于企业帐号支付以及退款原路返回，请使用扩展名为p12的证书文件</div>
                                    </el-upload>
                                </el-form-item>
                                <el-form-item>
                                    <!-- <el-button>关闭</el-button> -->
                                    <el-button @click="sendPayOption2">提交</el-button>
                                </el-form-item>
                            </div>
                        </el-form>
                    </div>
                </el-tab-pane>
                </div>
            </el-tabs>
        </div>
    </div>
</template>

<script>
import headerNotice from './../../components/common/headerNotice.vue'
export default {
    data() {
        return {
            baseUrl: this.$store.state.apiUrl,
            uploadAction: this.$store.state.apiUrl + '/api/services/app/File/UploadFile',//上传的服务器api地址
            headers: {
                'Authorization': localStorage.getItem('accessToken'),
            },
            accept:".jpg,.jpeg,.png,.JPG,.JPEG,.PNG",
            activeName: '0',//1客户端2业务员
            loading: true,
            ClientForm: {//表单
                MchId: '',
                AppId: '',
                AppSecret: '',
                Key: '',
                acceptanceId: '',
                app: '',
                fileName: '',
                CertPath: '',
            },
            ClientForm2: {//表单2
                MchId: '',
                AppId: '',
                AppSecret: '',
                Key: '',
                acceptanceId: '',
                app: '',
                fileName: '',
                CertPath: '',
            },
            clientFileList: [],//上传数据
        }
    },
    components: {
        headerNotice
    },
    mounted() {
        this.getDatas();
    },
    methods: {
        //获取列表数据
        getDatas() {
            let self = this;
            self.loading = true;
            $http.GET({
                url: this.$store.state.apiUrl + "/api/services/app/AdminPay/GetWeiXinPayConfig",
                params: '',
                success(res) {
                    console.log(res);
                    self.ClientForm = res.Shopping;
                    //self.ClientForm2 = res.salesman;
                    console.log(self.ClientForm);
                    //console.log(self.ClientForm2);
                    self.loading = false;
                },
                fail(res) {
                    console.log(res);
                    self.loading = false;
                }
            })
        },
        //提交
        sendPayOption() {
            let self = this;
            this.ClientForm.app = this.activeName;
            let form = this.ClientForm;
            $http.POST({
                url: this.$store.state.apiUrl + "/api/services/app/AdminPay/ModifyWeiXinPayConfig",
                data: form,
                success(res) {
                    console.log(res);
                    self.$message({
                        message: res.data,
                        type: 'success'
                    });
                },
                fail(res) {
                    console.log(res);
                    self.$message({
                        message: res.message,
                        type: 'warning'
                    });
                }
            })
        },
        sendPayOption2() {
            let self = this;
            this.ClientForm2.app = this.activeName;
            let form = this.ClientForm2;
            $http.POST({
                url: this.$store.state.apiUrl + "/api/services/app/AdminPay/ModifyWeiXinPayConfig",
                data: form,
                success(res) {
                    console.log(res);
                    self.$message({
                        message: res.data,
                        type: 'success'
                    });
                },
                fail(res) {
                    console.log(res);
                    self.$message({
                        message: res.message,
                        type: 'warning'
                    });
                }
            })
        },
        handleChange(file, fileList) {
            this.clientFileList = fileList.slice(-3);
        },
        //上传图片之前,尚未知道p12文件属性后缀
        // beforeUpload(file) {
        //     const isLt2M = file.size / 1024 / 1024 < 1;
        //     if (file.type != 'text/p12') {
        //         this.$message.error('上传的证书只支持p12的格式!');
        //         return false;
        //     }
        //     return true;
        //     if (!isLt2M) {
        //         this.$message.error('上传证书大小不能超过 1MB!');
        //     }
        //     return isLt2M;
        // },
        //图片上传成功
        handleAddSuccess(response, file, fileList) {
            console.log(response);
            this.ClientForm.fileName = response.result.fileName;
            // this.headImgUrl = URL.createObjectURL(file.raw);
        },
    }
}
</script>

<style lang='scss' scoped>
.payOptionPage {
    .payOptionMain {
        width: 40%;
        margin: 20px auto;
        padding: 10px;
        background: white;
        border: 1px solid #c5c5c5;
        .payOptionTitle {
            height: 40px;
            span {
                padding-left: 10px;
            }
        }
    }
}
</style>